import { render, staticRenderFns } from "./uploadKit.vue?vue&type=template&id=0bd06957&"
import script from "./uploadKit.vue?vue&type=script&lang=js&"
export * from "./uploadKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports